"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CreateFormConnector = props => {
  const {
    children,
    schema,
    ...rest
  } = props;
  return _react.default.cloneElement(children, {
    ...rest,
    schema
  });
};
var _default = exports.default = CreateFormConnector;
module.exports = exports.default;